<template>
  <div id="gene">
    <vice-title>
      <h3>{{ this.$t("lang.BetterMedicalCare.geneticTesting") }}</h3>
    </vice-title>
    <div class="hexagon">
      <img :src="this.$t('lang.imgUrl.bmcHexagon')" alt="" />
    </div>
    <div class="gene-detection">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
        this.$t("lang.BetterMedicalCare.geneDetection1")
      }}
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
        this.$t("lang.BetterMedicalCare.geneDetection2")
      }}
    </div>
    <div class="details">
      <a href="http://47.99.101.7:8080/pdf/基因检测明细表.pdf" target="_blank">
        <p>
          {{ this.$t("lang.BetterMedicalCare.detailsTesting") }}
          <span class="iconfont">&#xe603;</span>
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "GeneDetection",
  components: {
    ViceTitle
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#gene {
  width: 75%;
  margin: 0 auto;
  overflow: hidden;
  .hexagon {
    height: 420px;
    width: 730px;
    /*width: 100%;*/
    margin: 100px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .gene-detection {
    /*margin: 30px;*/
    line-height: 32px;
    color: #acacac;
    font-size: 18px;
  }
  .details {
    margin-top: 30px;
    text-align: center;
    color: $publicBlue;
    font-size: 16px;
    margin-bottom: 50px;
    p {
      color: $publicBlue;
    }
  }
}
</style>
